import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import constants from "./constants.js";
import FileSaver from 'file-saver';


Vue.use(Vuex);

// TODO: Refactor API calls so hasNext and hasPrevious are set via a function to reduce repeated code
// Add query string to set offsets against for pagination
export default new Vuex.Store({
  state: {
    apiData: [],
    apiURL: constants.API_ENDPOINT,
    apiLoading: true,
    hasNext: false,
    hasPrevious: false,
    currentPage: "",
    nextPage: "",
    previousPage: "",
    productCount: "",
    dataReady: false,
    perPage: 6,
    queryString: "",
    queryStringForDownload: '',
    paginationRows: "",
    paginationCurrentPage: 1,
    apiDataDownload: null,
  },
  getters: {
    apiData: state => state.apiData
  },
  mutations: {
    callAPI(state, payload) {
      // console.log('query_string\n' + payload)
      state.queryStringForDownload = payload;
      state.apiDataDownload = null;
      if (payload == null) {
        axios
          .get(state.apiURL, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          })
          .then(response => {
            state.apiData = response.data;
            // state.currentPage = 1;
            state.productCount = response.data.count;
            state.apiLoading = false;

            if (response.data.next == null) {
              state.hasNext = false;
            } else {
              state.hasNext = true;
              state.nextPage = response.data.next;
            }
            if (response.data.previous == null) {
              state.hasPrevious = false;
            } else {
              state.hasPrevious = true;
              state.previousPage = response.data.previous;
            }

            state.dataReady = true;
          });
      } else if (payload.charAt(0) == "?") {
        state.queryString = payload;
        // console.log(state.queryString);
        let query_string = state.apiURL + payload;
        // console.log("Query string: " + query_string)

        axios
          .get(query_string, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          })
          .then(response => {
            state.apiData = response.data;
            state.apiLoading = false;
            state.productCount = response.data.count;
            // if (response.data.previous == null) {
            //   state.currentPage = 1;
            // } else {
            //   state.currentPage =
            //     payload.substring(
            //       payload.search("offset=") + 7,
            //       payload.length
            //     ) /
            //       6 +
            //     1;
            // }

            if (response.data.next == null) {
              state.hasNext = false;
            } else {
              state.hasNext = true;
              state.nextPage = response.data.next;
            }
            if (response.data.previous == null) {
              state.hasPrevious = false;
            } else {
              state.hasPrevious = true;
              state.previousPage = response.data.previous;
            }
            state.dataReady = true;
          });
      } else {
        let query_string = payload;
        axios
          .get(query_string, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          })
          .then(response => {
            state.apiData = response.data;
            state.productCount = response.data.count;
            state.apiLoading = false;
            // if (response.data.previous == null) {
            //   state.currentPage = 1;
            // } else {
            //   state.currentPage =
            //     payload.substring(
            //       payload.search("offset=") + 7,
            //       payload.length
            //     ) /
            //       6 +
            //     1;
            // }

            if (response.data.next == null) {
              state.hasNext = false;
            } else {
              state.hasNext = true;
              state.nextPage = response.data.next;
            }
            if (response.data.previous == null) {
              state.hasPrevious = false;
            } else {
              state.hasPrevious = true;
              state.previousPage = response.data.previous;
            }
            state.dataReady = true;
          });
      }
    },
    callAPIDownloadResults(state, payload) {
      // console.log('in download results')
      // let url = "http://localhost:8000/api/v1/ProductListDownload/"
      let url = "https://certifications.sunspec.org/api/v1/ProductListDownload/"
      if (payload == null) {
        // console.log('in null')
        axios
          .get(url, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          })
          .then(response => {
            state.apiDataDownload = response.data;
            // console.log(state.apiDataDownload)
            var blob = new Blob([JSON.stringify(state.apiDataDownload, null, 1)], {type: 'application/json	'})
            FileSaver.saveAs(blob, "SunSpec-Certs.json")  
            // state.currentPage = 1;
          });
      } else if (payload.charAt(0) == "?") {
        // console.log('in queyr string')
        state.queryString = payload;
        // console.log(state.queryString);
        let query_string = url + payload;
        // console.log(query_string)
        query_string = query_string.replace('products', 'ProductListDownload')
        // console.log("Query string: " + query_string)

        axios
          .get(query_string, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          })
          .then(response => {
            state.apiDataDownload = response.data;
            var blob = new Blob([JSON.stringify(state.apiDataDownload, null, 1)], {type: 'application/json	'})
            FileSaver.saveAs(blob, "SunSpec-Certs.json")  
          });
      } else {
        // console.log('in else')
        let query_string = payload;
        query_string = query_string.replace('products', 'ProductListDownload')

        axios
          .get(query_string, {
            headers: {
              Authorization: "Token 7efbd44a97989e4cfae99715eb3e2435d86ad5df"
            }
          })
          .then(response => {
            state.apiDataDownload = response.data;
            var blob = new Blob([JSON.stringify(state.apiDataDownload, null, 1)], {type: 'application/json	'})
            FileSaver.saveAs(blob, "SunSpec-Certs.json")  
          });
          // console.log(query_string)
      }
    },
    toggleAPILoading(state) {
      state.apiLoading = !state.apiLoading;
    },
    toggleDataReady(state) {
      state.dataReady = false;
    },
    clearQueryString(state) {
      state.queryString = "";
    }
  }
});
